export default __webpack_public_path__ + "static/media/cob2.9e6e5e81.png";